import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DivisionTblDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-division',
  templateUrl: './division.component.html',
  styleUrls: ['./division.component.scss']
})
export class DivisionComponent implements OnChanges {


  divisionForm: FormGroup;
  divisionFormArray: FormGroup;
  control = new FormControl();
  @Input() divisions: DivisionTblDto[];
  @Input() routeAnimationsElements: any;
  @Output() division = new EventEmitter<DivisionTblDto[]>()
  @Output() deleteDivisionEvent = new EventEmitter<any>()

    selectedDivision: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createDivisionForm();
    }

    createDivisionForm() {
      this.divisionForm = this.fb.group({
        DivisionName: ['', Validators.required],
        DivisionCode: [''],
        id: null
        });
        this.divisionFormArray = this.fb.group({ Divisions: this.fb.array([])
          });
        this.setDivision();
    }

  // method to display divisions
  setDivision() {
    const control  = this.divisionFormArray.controls.Divisions as FormArray;
    this.divisions.forEach( e => {
      control.push(
        this.fb.group({
          DivisionName: e.DivisionName,
          DivisionCode: e.DivisionCode,
          id: e.id
        })
      );
    });
  }


  // method to add Division
  addDivision(value: DivisionTblDto) {
    const control  = this.divisionFormArray.controls.Divisions as FormArray;
    control.insert(0,
          this.fb.group({
            DivisionName: value.DivisionName,
            DivisionCode: value.DivisionCode,
            id: null
          })
       );
  }

  selectDivision(value) {}

  // method to delete division from arrary list
  deleteDivision(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.divisionFormArray.controls.Divisions as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.divisions.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.divisions[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: DivisionTblDto) {
    if(this.divisionForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.divisionFormArray.get('Divisions')['controls'][this.selectedIndex].patchValue({DivisionName: formValue.DivisionName, DivisionCode: formValue.DivisionCode});
    } else {
      this.addDivision(formValue);
    }
    this.selectedIndex = null;
    this.divisionForm.reset()
  }

  onEdit(index, value: DivisionTblDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.divisionForm.patchValue({DivisionName: value.DivisionName, DivisionCode: value.DivisionCode});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.divisionForm.reset();
  }

  onSubmit(formValue: DivisionTblDto[]) {
  this.division.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteDivisionEvent.emit(this.filteredDelete);
  }
  }

}
